
import { Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type, class_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { replace, join, concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { DashboardBlockModule_ofKey, DashboardBlockSize, DashboardBlockSizeModule_key, DashboardBlockModule_key } from "../Shared/DashboardConfiguration.js";
import { initialize, map, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { max } from "../fable_modules/fable-library-js.5.0.0-rc.2/Double.js";
import { reactElement, reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useLayoutEffectWithDeps } from "../fable_modules/Feliz.2.9.0/ReactInterop.js";
import { createDisposable } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { createElement } from "react";
import React from "react";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import Block_Width_Small from "../../public/assets/icons/Block_Width_Small.svg";
import Block_Width_Medium from "../../public/assets/icons/Block_Width_Medium.svg";
import Block_Width_Large from "../../public/assets/icons/Block_Width_Large.svg";
import { useTranslation } from "react-i18next";
import { useSortableDrop, useDrag } from "../Bindings/Fable.ReactDnD.js";
import { Msg } from "./Types.js";
import Drag_Grip from "../../public/assets/icons/Drag_Grip.svg";
import { IconSegmentedControl } from "../Components/SegmentedControl.js";
import { Button, TextButton, IconToolButton } from "../Components/Button.js";
import Invisible_1 from "../../public/assets/icons/Invisible_1.svg";
import { BlockHeader } from "../Components/Text.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Select } from "../Components/Select.js";
import Pencil from "../../public/assets/icons/Pencil.svg";

export class BlockContent extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Unavailable", "Empty", "Content"];
    }
}

export function BlockContent_$reflection() {
    return union_type("Dashboard.Layout.BlockContent", [], BlockContent, () => [[], [], [["Item", class_type("Fable.React.ReactElement")]]]);
}

export function blockTitleKey(block) {
    switch (block.tag) {
        case 1:
            return "dashboard.open_notifications";
        case 2:
            return "dashboard.running_stocktakings";
        case 3:
            return "dashboard.inspection_status_title";
        case 4:
            return "dashboard.problem_reports";
        case 5:
            return "general.in_maintenance";
        case 6:
            return "general.appointments";
        case 7:
            return "dashboard.availability_title";
        case 8:
            return "dashboard.tool_return_date_title";
        case 9:
            return "dashboard.minimum_stock";
        case 10:
            return "dashboard.tool_next_reservations_title";
        case 11:
            return "dashboard.release_dates";
        default:
            return "dashboard.configuration.tracker_map";
    }
}

function blockTestId(block) {
    return concat("dashboard-block-", ...DashboardBlockModule_key(block));
}

export const gridClasses = ofArray(["grid", "grid-cols-1", "lg:grid-cols-2", "2xl:grid-cols-3", "gap-x-8", "auto-rows-[4px]", "items-start"]);

function sizeClasses(size) {
    return toList(delay(() => append(singleton("col-span-1"), delay(() => {
        const matchValue = size;
        return (matchValue.tag === 1) ? append(singleton("lg:col-span-2"), delay(() => singleton("2xl:col-span-2"))) : ((matchValue.tag === 2) ? append(singleton("lg:col-span-2"), delay(() => singleton("2xl:col-span-3"))) : append(singleton("lg:col-span-1"), delay(() => singleton("2xl:col-span-1"))));
    }))));
}

const rowHeight = 4;

const rowGap = 16;

function rowSpanOf(height) {
    return max(1, ~~Math.ceil((height + rowGap) / rowHeight)) | 0;
}

function useRowSpan() {
    const element = reactApi.useRef(undefined);
    const patternInput = reactApi.useState(1);
    useLayoutEffectWithDeps(() => {
        const matchValue = element.current;
        if (matchValue == null) {
            return createDisposable(() => {
            });
        }
        else {
            const current = matchValue;
            const measure = () => {
                patternInput[1](rowSpanOf(current.getBoundingClientRect().height));
            };
            measure();
            const observer = new ResizeObserver(measure);
            observer.observe(current);
            return createDisposable(() => {
                observer.disconnect();
            });
        }
    }, []);
    return [element, patternInput[0]];
}

export function GridItem(props) {
    const patternInput = useRowSpan();
    return reactElement("div", createObj(toList(delay(() => append(props.Attributes, delay(() => append(singleton(["className", join(" ", toList(delay(() => append(sizeClasses(props.Size), delay(() => singleton("pb-4"))))))]), delay(() => append(singleton(["style", {
        gridRowEnd: `span ${patternInput[1]}`,
    }]), delay(() => {
        let elems_1;
        return singleton((elems_1 = [reactElement("div", {
            ref: patternInput[0],
            children: reactApi.Children.toArray([props.Children]),
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))]));
    }))))))))));
}

export function blockAttributes(configuration) {
    return ofArray([["data-test-id", blockTestId(configuration.Block)], ["data-size", DashboardBlockSizeModule_key(configuration.Size)]]);
}

function sizeOptions(t, key) {
    let Icon, Title, Icon_1, Title_1, Icon_2, Title_2;
    return ofArray([(Icon = Block_Width_Small(), (Title = t("dashboard.configuration.size_small"), {
        Icon: Icon,
        TestId: concat("dashboard-block-size-", key, ..."-small"),
        Title: Title,
        Value: new DashboardBlockSize(0, []),
    })), (Icon_1 = Block_Width_Medium(), (Title_1 = t("dashboard.configuration.size_medium"), {
        Icon: Icon_1,
        TestId: concat("dashboard-block-size-", key, ..."-medium"),
        Title: Title_1,
        Value: new DashboardBlockSize(1, []),
    })), (Icon_2 = Block_Width_Large(), (Title_2 = t("dashboard.configuration.size_large"), {
        Icon: Icon_2,
        TestId: concat("dashboard-block-size-", key, ..."-large"),
        Title: Title_2,
        Value: new DashboardBlockSize(2, []),
    }))]);
}

const dragType = "DASHBOARD_BLOCK";

const moveCooldownMilliseconds = 150;

export function EditableBlock(props) {
    let elems_5;
    const t = useTranslation()[0];
    const block = props.Configuration.Block;
    const key = DashboardBlockModule_key(block);
    const patternInput_1 = useDrag({
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        item: (_arg) => {
            props.LastMove.current = 0;
            return {
                id: key,
            };
        },
        type: dragType,
    });
    const dragState = patternInput_1[0];
    return reactElement("div", createObj(ofArray([["ref", useSortableDrop({
        accept: dragType,
        drop: (value) => {
        },
        hover: (dragged) => {
            const now = Date.now();
            const matchValue = DashboardBlockModule_ofKey(dragged.id);
            let matchResult_1, source_1;
            if (matchValue != null) {
                if (((props.ComponentState === "enabled") && (DashboardBlockModule_key(matchValue) !== key)) && ((now - props.LastMove.current) > moveCooldownMilliseconds)) {
                    matchResult_1 = 0;
                    source_1 = matchValue;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    props.LastMove.current = now;
                    props.Dispatch(new Msg(5, [source_1, block]));
                    break;
                }
                case 1: {
                    break;
                }
            }
        },
    })[1]], ["data-test-id", concat("dashboard-block-drop-", ...key)], ["data-dragging", dragState.isDragging ? "true" : "false"], ["className", join(" ", ["relative"])], (elems_5 = toList(delay(() => {
        let elems_4;
        return append(singleton(reactElement("div", createObj(ofArray([["ref", patternInput_1[2]], ["className", join(" ", toList(delay(() => append(singleton("group"), delay(() => append(singleton("rounded"), delay(() => append(singleton("bg-white"), delay(() => append(singleton("border"), delay(() => append(singleton("border-border"), delay(() => append(singleton("hover:border-border-muted/40"), delay(() => append(singleton("transition-colors"), delay(() => (dragState.isDragging ? singleton("invisible") : empty()))))))))))))))))))], (elems_4 = toList(delay(() => {
            let elems_2, elems_1, elems, Icon, Title;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-3", "px-3", "py-1.5", "border-b", "border-border"])], (elems_2 = [reactElement("div", createObj(ofArray([["ref", patternInput_1[1]], ["data-test-id", concat("dashboard-block-handle-", ...key)], ["title", t("dashboard.configuration.drag_handle")], ["className", join(" ", ["flex", "items-center", "gap-2", "flex-grow", "min-w-0", "cursor-grab", "active:cursor-grabbing"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4", "shrink-0", "text-border-muted/60", "group-hover:text-text-muted"])], (elems = [Drag_Grip()], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", {
                className: join(" ", ["text-xs", "text-text-muted", "truncate"]),
                children: t("dashboard.configuration.drag_handle"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(IconSegmentedControl, {
                ComponentState: props.ComponentState,
                OnChange: (size) => {
                    props.Dispatch(new Msg(8, [block, size]));
                },
                Options: sizeOptions(t, key),
                TestId: concat("dashboard-block-size-", ...key),
                Value: props.Configuration.Size,
            }), createElement(IconToolButton, (Icon = Invisible_1(), (Title = t("dashboard.configuration.hide"), {
                ComponentState: props.ComponentState,
                Icon: Icon,
                OnClick: () => {
                    props.Dispatch(new Msg(6, [block]));
                },
                TestId: concat("dashboard-block-toggle-", ...key),
                Title: Title,
            })))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                let elems_3;
                const matchValue_1 = props.Content;
                return (matchValue_1.tag === 1) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_3 = [createElement(BlockHeader, {
                    Text: blockTitleKey(block),
                }), reactElement("div", {
                    className: join(" ", ["text-sm", "text-text-muted"]),
                    children: t("dashboard.configuration.empty_block"),
                })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : ((matchValue_1.tag === 0) ? singleton(defaultOf()) : singleton(matchValue_1.fields[0]));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => (dragState.isDragging ? singleton(reactElement("div", {
            "data-test-id": concat("dashboard-block-gap-", ...key),
            className: join(" ", ["absolute", "inset-0", "flex", "items-center", "justify-center", "p-4", "text-center", "rounded", "border-2", "border-dashed", "border-primary", "bg-primary/15", "text-sm", "font-bold"]),
            children: replace(t("dashboard.configuration.gap_label"), "{{block}}", t(blockTitleKey(block))),
        })) : empty())));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

export function EditToolbar(props) {
    let elems_1, elems;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["data-test-id", "dashboard-edit-toolbar"], ["className", join(" ", ["flex", "flex-wrap", "items-center", "gap-4", "bg-white", "p-4", "rounded"])], (elems_1 = [reactElement("div", {
        className: join(" ", ["text-sm", "flex-grow", "basis-80"]),
        children: t("dashboard.configuration.edit_hint"),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["w-72"])], (elems = [createElement(Select, {
        ComponentState: componentState,
        IsClearable: false,
        NoOptionsMessage: "dashboard.configuration.all_blocks_shown",
        OnChange: (selected) => {
            if (selected == null) {
            }
            else {
                props.Dispatch(new Msg(7, [selected.value]));
            }
        },
        Options: map((block) => ({
            label: t(blockTitleKey(block)),
            value: block,
        }), props.HiddenBlocks),
        PlaceholderKey: "dashboard.configuration.add_block",
        TestId: "dashboard-add-block",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(TextButton, {
        ComponentState: componentState,
        Label: t("dashboard.configuration.reset"),
        OnClick: () => {
            props.Dispatch(new Msg(12, []));
        },
        TestId: "dashboard-reset",
        Variant: "default",
    }), createElement(Button, {
        ComponentState: componentState,
        Label: t("general.cancel"),
        OnClick: () => {
            props.Dispatch(new Msg(9, []));
        },
        TestId: "dashboard-cancel",
        Variant: "secondary",
    }), createElement(Button, {
        ComponentState: componentState,
        Label: t("general.save"),
        OnClick: () => {
            props.Dispatch(new Msg(10, []));
        },
        TestId: "dashboard-save",
        Variant: "primary",
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function CustomizeButton(props) {
    let elems, Label;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex"])], (elems = [createElement(TextButton, (Label = patternInput[0]("dashboard.configuration.customize"), {
        ComponentState: "enabled",
        Icon: Pencil(),
        Label: Label,
        OnClick: () => {
            props.Dispatch(new Msg(4, [props.Blocks]));
        },
        TestId: "dashboard-customize",
        Variant: "mutedLink",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function SkeletonCard(props) {
    let elems_1, elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(sizeClasses(props.Size), delay(() => singleton("pb-4"))))))], ["style", {
        gridRowEnd: `span ${rowSpanOf(88 + (props.Lines * 28))}`,
    }], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded", "flex", "flex-col", "gap-3"])], (elems = toList(delay(() => append(singleton(reactElement("div", {
        className: join(" ", ["h-4", "w-40", "rounded-full", "bg-skeleton-grey", "mb-3"]),
    })), delay(() => initialize(props.Lines, (index) => reactElement("div", {
        className: join(" ", toList(delay(() => append(singleton("h-4"), delay(() => append(singleton("rounded-full"), delay(() => append(singleton("bg-skeleton-grey"), delay(() => {
            const matchValue = (index % 3) | 0;
            return (matchValue === 0) ? singleton("w-full") : ((matchValue === 1) ? singleton("w-5/6") : singleton("w-2/3"));
        }))))))))),
    })))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function DashboardSkeleton() {
    let elems_2, elems, elems_1;
    return reactElement("div", createObj(ofArray([["data-test-id", "dashboard-skeleton"], ["role", join(" ", ["status"])], ["className", join(" ", ["flex", "flex-col", "gap-4", "animate-pulse"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end"])], (elems = [reactElement("div", {
        className: join(" ", ["h-4", "w-36", "rounded-full", "bg-skeleton-grey"]),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", gridClasses)], (elems_1 = [createElement(SkeletonCard, {
        Lines: 5,
        Size: new DashboardBlockSize(1, []),
    }), createElement(SkeletonCard, {
        Lines: 3,
        Size: new DashboardBlockSize(0, []),
    }), createElement(SkeletonCard, {
        Lines: 4,
        Size: new DashboardBlockSize(0, []),
    }), createElement(SkeletonCard, {
        Lines: 2,
        Size: new DashboardBlockSize(0, []),
    }), createElement(SkeletonCard, {
        Lines: 3,
        Size: new DashboardBlockSize(0, []),
    }), createElement(SkeletonCard, {
        Lines: 4,
        Size: new DashboardBlockSize(0, []),
    }), createElement(SkeletonCard, {
        Lines: 3,
        Size: new DashboardBlockSize(0, []),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

